const nutritionDiv = $('#nutrition-container');
let nutritionProtein = [];
let nutritionProteinn = [];
let nutritionCarb = [];
let nutritionCarbb = [];
let nutritionFactItems = [];

nutritionDiv.hide();

// Number.prototype.toFixedNoRounding = function(n) {
//   const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g")
//   const a = this.toString().match(reg)[0];
//   const dot = a.indexOf(".");
//   if (dot === -1) { // integer, insert decimal dot and pad up zeros
//       return a + "." + "0".repeat(n);
//   }
//   const b = n - (a.length - dot) + 1;
//   return b > 0 ? (a + "0".repeat(b)) : a;
// }

Number.prototype.toFixedNoRounding = function(n) {
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
  const a = this.toString().match(reg)[0];
  const dot = a.indexOf(".");

  // If there's no decimal point, just return the padded integer
  if (dot === -1) {
    return a + "." + "0".repeat(n);
  }

  const b = n - (a.length - dot) + 1;
  const result = b > 0 ? (a + "0".repeat(b)) : a;

  // Check if the number is very close to a whole number (like 29.99)
  if (this - Math.floor(this) >= 0.99) {
    return (Math.ceil(this)).toFixed(n);  // Round up and add fixed decimal places
  }

  return result;
};

// test cedric
function nutritionTable(){

  nutritionFactItems = [...nutritionProtein,...nutritionProteinn,...nutritionCarb,...nutritionCarbb];

const nutritionFact = {
   /* PROTEINS */
   'black bean vegan patty': {
      calorie: 150,
      protein: 8,
      carb: 27,
      fat: 1.5,
      sodium: 610,
      fiber: 9,
   },
   'beyond meat vegan patty': {
      calorie: 280,
      protein: 20,
      carb: 6,
      fat: 20,
      sodium: 390,
      fiber: 2,
   },
   brisket: {
      calorie: 67.5,
      protein: 9.3,
      carb: 0,
      fat: 3.3,
      sodium: 112.5,
      fiber: 0,
   },
   chicken: {
      calorie: 40,
      protein: 8.666666666666667,
      carb: 0,
      fat: 0.6666666666666667,
      sodium: 35,
      fiber: 0,
   },
   'chicken breast': {
      calorie: 40,
      protein: 8.8,
      carb: 0,
      fiber: 0,
      fat: 0.6,
      sodium: 37.5,
   },
   'chicken thighs': {
      calorie: 52.5,
      protein: 7.3,
      carb: 0,
      fiber: 0,
      fat: 2.5,
      sodium: 50,
   },
   cod: {
      calorie: 22.5,
      protein: 5.8,
      carb: 0,
      fiber: 0,
      fat: 0,
      sodium: 23.8,
   },
   'egg whites': {
      calorie: 16.66666666666667,
      protein: 4,
      carb: 0,
      fiber: 0,
      fat: 0,
      sodium: 56.66666666666667,
   },
   'ground beef': {
      calorie: 65,
      protein: 8.5,
      carb: 0.5,
      fiber: 0,
      fat: 3.3,
      sodium: 35,
   },
   'ground bison': {
      calorie: 65,
      protein: 6.8,
      carb: 0,
      fiber: 0,
      fat: 4,
      sodium: 21.3,
   },
   'ground turkey': {
      calorie: 55,
      protein: 6.8,
      carb: 0.5,
      fiber: 0,
      fat: 3,
      sodium: 57.5,
   },
   salmon: {
      calorie: 50,
      protein: 7,
      carb: 0,
      fiber: 0,
      fat: 2.5,
      sodium: 23.8,
   },
   shrimp: {
      calorie: 27.5,
      protein: 5.8,
      carb: 0.3,
      fiber: 0,
      fat: 0.3,
      sodium: 82.5,
   },
   steak: {
      calorie: 47.5,
      protein: 8.3,
      carb: 0.8,
      fiber: 0,
      fat: 1.3,
      sodium: 40,
   },
   'turkey bacon': {
      calorie: 40,
      protein: 3,
      carb: 0,
      fiber: 0,
      fat: 3,
      sodium: 160,
   },
   'turkey breast': {
      calorie: 35,
      protein: 7.5,
      carb: 0,
      fiber: 0,
      fat: 0.5,
      sodium: 95,
   },
   'whole egg': {
      calorie: 50,
      protein: 5,
      carb: 0,
      fiber: 0,
      fat: 3.5,
      sodium: 50,
   },
   /* SIDES */
   asparagus: {
      calorie: 3.8,
      protein: 0.5,
      carb: 0.8,
      fat: 0,
      sodium: 0,
      fiber: 0.5,
   },
   broccoli: {
      calorie: 9,
      protein: 0.7,
      carb: 1.4,
      fiber: 0.7,
      fat: 0,
      sodium: 5.4,
   },
   'brown rice': {
      calorie: 50,
      protein: 1.1,
      carb: 10.8,
      fiber: 0,
      fat: 0.3,
      sodium: 1.1,
   },
   cauliflower: {
      calorie: 15,
      protein: 1,
      carb: 2.5,
      fiber: 1,
      fat: 0,
      sodium: 15,
   },
   'green beans': {
      calorie: 11.3,
      protein: 0.8,
      carb: 2,
      fiber: 0.8,
      fat: 0,
      sodium: 0,
   },
   'jasmine saffron rice': {
      calorie: 40,
      protein: 0.8,
      carb: 9.4,
      fiber: 0,
      fat: 0,
      sodium: 56,
   },
   'kyoto blend veggies': {
      calorie: 24.5,
      protein: 1.9,
      carb: 3.4,
      fiber: 0,
      fat: 0.7,
      sodium: 7.3,
   },
   'gluten free penne pasta': {
      calorie: 70,
      protein: 1.5,
      carb: 15,
      fat: 0.25,
      sodium: 0,
      fiber: 0.25,
   },
   oatmeal: {
      calorie: 90,
      protein: 3,
      carb: 16.5,
      fiber: 2.4,
      fat: 1.8,
      sodium: 0,
   },
   quinoa: {
      calorie: 50,
      protein: 2,
      carb: 10,
      fat: 1,
      sodium: 70,
      fiber: 0,
   },
   'red quinoa': {
      calorie: 30,
      protein: 1.1,
      carb: 5.2,
      fiber: 0.5,
      fat: 0.5,
      sodium: 0,
   },
   'quinoa rice blend': {
      calorie: 60,
      protein: 2,
      carb: 10,
      fat: 1,
      sodium: 60,
      fiber: 0,
   },
   'red potatoes': {
      calorie: 25,
      protein: 0.5,
      carb: 4.8,
      fiber: 0.5,
      fat: 0.4,
      sodium: 1.3,
   },
   'sauteed carrots': {
      calorie: 17.5,
      protein: 0,
      carb: 2.5,
      fiber: 1,
      fat: 0.75,
      sodium: 20,
   },
   'sweet potato mash': {
      calorie: 32.5,
      protein: 0.5,
      carb: 6.3,
      fiber: 1,
      fat: 0.5,
      sodium: 0,
   },
   'sweet potatoes': {
      calorie: 30,
      protein: 0.5,
      carb: 5.5,
      fiber: 0.8,
      fat: 0.6,
      sodium: 15,
   },
   'white rice': {
      calorie: 60,
      protein: 1.4,
      carb: 13.9,
      fiber: 0,
      fat: 0.1,
      sodium: 0,
   },
   /* CARBS */
   'home style protein pancakes': {
      calorie: 180,
      protein: 16,
      carb: 27,
      fiber: 0,
      fat: 0.5,
      sodium: 350,
   },
   'original oats': {
      calorie: 10,
      protein: 0.375,
      carb: 1.75,
      fat: 0.1875,
      sodium: 0,
      fiber: 6.5,
   },
}; // end of nutritinoFact

  let nutritionData = '';
  let calorieTotal = 0;
  let proteinTotal = 0;
  let carbTotal = 0;
  let fatTotal = 0;
  let sodiumTotal = 0;
  let fiberTotal = 0;

  nutritionFactItems.forEach(( item ) => {
    
  console.log(item);

  const itemName = item.item;
  const ozVal = Number(item.oz);

  const calorie = nutritionFact[itemName].calorie * ozVal;
  const protein =  nutritionFact[itemName].protein * ozVal;
  const carb =  nutritionFact[itemName].carb * ozVal;
  const fat =  nutritionFact[itemName].fat * ozVal;
  const sodium =  nutritionFact[itemName].sodium * ozVal;
  const fiber =  nutritionFact[itemName].fiber * ozVal;

  calorieTotal += Number(calorie);
  proteinTotal += Number(protein);
  carbTotal += Number(carb);
  fatTotal += Number(fat);
  sodiumTotal += Number(sodium);
  fiberTotal += Number(fiber);

  nutritionData += 
  `<tr>
    <td class="item">${itemName}</td>
    <td>${(calorie).toFixedNoRounding(2)}</td>
    <td>${(protein).toFixedNoRounding(2)}</td>
    <td>${(carb).toFixedNoRounding(2)}</td>
    <td>${(fat).toFixedNoRounding(2)}</td>
    <td>${(sodium).toFixedNoRounding(2)}</td>
    <td>${(fiber).toFixedNoRounding(2)}
   </tr>
  `;

  });

  const generatedTable = 
  `<table>
    <thead>
      <th style="text-transform: capitalize;">Item <br/></th>
      <th style="text-transform: capitalize;">Calories <br/><span style="text-transform: lowercase"></span></th>
<th style="text-transform: capitalize;">Protein <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Carbs <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Fat <br/><span style="text-transform: lowercase">(g)</span></th>
      <th style="text-transform: capitalize;">Sodium <br/><span style="text-transform: lowercase">(mg)</span></th>
      <th style="text-transform: capitalize;">Fiber <br/><span style="text-transform: lowercase">(g)</span></th>
    </thead>
    <tbody>${nutritionData}</tbody>
    <tfoot>
      <th style="text-transform: capitalize;">Total</th>
      <th>${(calorieTotal).toFixedNoRounding(2)}</th>
      <th>${(proteinTotal).toFixedNoRounding(2)}</th>
      <th>${(carbTotal).toFixedNoRounding(2)}</th>
      <th>${(fatTotal).toFixedNoRounding(2)}</th>
      <th>${(sodiumTotal).toFixedNoRounding(2)}</th>
      <th>${(fiberTotal).toFixedNoRounding(2)}</th>
    </tfoot>
  </table>`;
  
  if ( nutritionFactItems.length > 0 ) {
    nutritionDiv.show();
    nutritionDiv.html(generatedTable);
    $('.money').show();
  } else {
    nutritionDiv.hide();
    nutritionDiv.html(generatedTable);
    $('.money').hide();      
  }

} // end of nutritionTable();


BOLD.options.app.on('option_changed', function(obj){

  /* custom meal */
  const proteinSelected = $('select.dd_1188045_479515').val();
  const sideSelected1 = $('select.dd_1188614_479515').val();
  const sideSelected2 =  $('select.dd_1188639_479515').val();
  
  /* breakfast meal */
  const protein2Selected = $('select.dd_1188667_479729').val();
  const sideSelected3 = $('select.dd_1188678_479729').val();

  /* custom oz data */
  let modifiedVal = false;

  // this logic to customize the swatch ouput into circle red 
  if(obj.data.option_key.indexOf('sw_') > -1){
    
    $('.'+obj.data.option_key).each(function(){

       const parentLbl = $(this).parents('label');
       const title = parentLbl.find('.bold_option_swatch_title .bold_option_value_title').html();
       let subHTML = '<sub class="oz">oz</sub>';
       
       if ( proteinSelected == 'Beyond Meat Vegan Patty' && obj.data.option.helpText == 'Protein' ) { subHTML = '<sub class="oz">ea</sub>'; }

       if ( proteinSelected == 'Black Bean Vegan Patty' && obj.data.option.helpText == 'Protein' ) { subHTML = '<sub class="oz">ea</sub>'; }

       if ( sideSelected1 == 'Brown Rice' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected1== 'Gluten Free Penne Pasta' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected1 == 'Jasmine Saffron Rice' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected1 == 'Kyoto Blend Veggies' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected1 == 'Quinoa' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }
      
       if ( sideSelected1 == 'Red Quinoa' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected1 == 'Quinoa Rice Blend' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected1 == 'White Rice' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected2 == 'Brown Rice' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected2 == 'Gluten Free Penne Pasta' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected2 == 'Jasmine Saffron Rice' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected2 == 'Kyoto Blend Veggies' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>'; modifiedVal = true; }

       if ( sideSelected2 == 'Quinoa' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }
      
       if ( sideSelected2 == 'Red Quinoa' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected2 == 'Quinoa Rice Blend' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( sideSelected2 == 'White Rice' && obj.data.option.helpText == 'Carbb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( protein2Selected == 'Turkey Bacon' && obj.data.option.helpText == 'Proteinn' ) { subHTML = '<sub class="oz">sl</sub>';  modifiedVal = true; }
      
       if ( protein2Selected == 'Beyond Meat Vegan Patty' && obj.data.option.helpText == 'Proteinn' ) { subHTML = '<sub class="oz">ea</sub>';  modifiedVal = true; }

       if ( protein2Selected == 'Black Bean Vegan Patty' && obj.data.option.helpText == 'Proteinn' ) { subHTML = '<sub class="oz">ea</sub>';  modifiedVal = true; }

       if ( sideSelected3 == 'Home Style Protein Pancakes' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">ea</sub>';  modifiedVal = true; }

       if ( sideSelected3 == 'Oatmeal' && obj.data.option.helpText == 'Carb' ) { subHTML = '<sub class="oz">c</sub>';  modifiedVal = true; }

       if ( ! modifiedVal ) {

        parentLbl.find('.bold_option_value_swatch span').html( isNaN(title) ? title : `${title} ${subHTML}`);

       } else {

        parentLbl.find('.bold_option_value_swatch span').html(`${title} ${subHTML}`);

       }
       

    }); 


  } // end of indexOf('sw_')

  let currentValOz = obj.data.option.getValue();

  if (obj.data.option.helpText == 'Protein'){

    const proteinName = $.trim(obj.data.option.internalName.replace(/OZ|EACH|CUP|SLICE/gi,'')).toLocaleLowerCase();
  
    if ( proteinName != '' && currentValOz != '' && !isNaN(currentValOz) ){

      nutritionProtein.push({ item: proteinName, oz: currentValOz });
      if ( nutritionProtein.length > 1 ) { nutritionProtein.shift();  }
      nutritionTable();  

    } else {

      nutritionProtein = [];
      nutritionTable(); 

    }
    
  } // end of Protein


  if (obj.data.option.helpText == 'Proteinn'){

    const proteinnName = $.trim(obj.data.option.internalName.replace(/OZ|EACH|CUP|SLICE/gi,'')).toLocaleLowerCase();

    if ( proteinnName != '' && currentValOz != '' && !isNaN(currentValOz) ){

      nutritionProteinn.push({ item: proteinnName, oz: currentValOz });
      if ( nutritionProteinn.length > 1 ) { nutritionProteinn.shift();  }
      nutritionTable();  

    } else {

      nutritionProteinn = [];
      nutritionTable(); 

    }

  } // end of Protein

  if (obj.data.option.helpText == 'Carb'){

    const carbName = $.trim(obj.data.option.internalName.replace(/OZ|EACH|CUP|SLICE/gi,'')).toLocaleLowerCase();


    if ( currentValOz === '1/4' && modifiedVal  ) { currentValOz = 1; }
    if ( currentValOz === '1/2' && modifiedVal && carbName !== 'oatmeal' ) { currentValOz = 2; }
    if ( currentValOz === '1' && modifiedVal && carbName !== 'home style protein pancakes' && carbName !== 'oatmeal' ) { currentValOz = 4; }
    if ( currentValOz === '1.5' && modifiedVal ) { currentValOz = 6; }
    if ( currentValOz === '2' && modifiedVal && carbName !== 'home style protein pancakes' && carbName !== 'oatmeal'  ) { currentValOz = 8; }

    if ( carbName === 'oatmeal' && currentValOz === '1/2' && modifiedVal ) { currentValOz = 2; }
    if ( carbName === 'oatmeal' && currentValOz === '1' && modifiedVal ) { currentValOz = 4; }
    if ( carbName === 'oatmeal' && currentValOz === '2' && modifiedVal ) { currentValOz = 8; }

    
    if ( carbName != '' && currentValOz != '' && !isNaN(currentValOz)){
       
      nutritionCarb.push({ item: carbName, oz: currentValOz });
      if ( nutritionCarb.length > 1 ) { nutritionCarb.shift();  }
      nutritionTable();  

    } else {

      nutritionCarb = [];
      nutritionTable(); 

    }

  } // end of Carb


  if (obj.data.option.helpText == 'Carbb'){ 

    const carbbName = $.trim(obj.data.option.internalName.replace(/OZ|EACH|CUP|SLICE/gi,'')).toLocaleLowerCase();

    if ( currentValOz === '1/4' && modifiedVal  ) { currentValOz = 1; }
    if ( currentValOz === '1/2' && modifiedVal  ) { currentValOz = 2; }
    if ( currentValOz === '1' && modifiedVal ) { currentValOz = 4; }
    if ( currentValOz === '1.5' && modifiedVal ) { currentValOz = 6; }
    if ( currentValOz === '2' && modifiedVal ) { currentValOz = 8; }

    if ( carbbName != '' && currentValOz != '' && !isNaN(currentValOz)){


    nutritionCarbb.push({ item: carbbName, oz: currentValOz });
    if ( nutritionCarbb.length > 1 ) { nutritionCarbb.shift();  }
    nutritionTable();  

    } else {

    nutritionCarbb = [];
    nutritionTable(); 

    }

  } // end of Carbb

}); // end of BOLD.options.app.on